document.documentElement.classList.remove('no-js');

const selectors = {
  drawerToggle: '[data-drawer-toggle]',
  drawerClose: '[data-drawer-close]',
  drawer: '[data-mobile-drawer]',
  productRoot: '[data-product-root]',
  optionInput: '[data-option-input]',
  variantId: '[data-variant-id]',
  variantPrice: '[data-variant-price]',
  addToCart: '[data-add-to-cart]',
  productMedia: '[data-product-media]',
  mediaThumb: '[data-media-thumb]',
  accordionToggle: '[data-accordion-toggle]',
};

function bindMobileDrawer() {
  const body = document.body;
  const drawer = document.querySelector(selectors.drawer);
  if (!drawer) return;

  document.querySelectorAll(selectors.drawerToggle).forEach((button) => {
    button.addEventListener('click', () => {
      body.classList.toggle('has-menu-open');
    });
  });

  document.querySelectorAll(selectors.drawerClose).forEach((button) => {
    button.addEventListener('click', () => {
      body.classList.remove('has-menu-open');
    });
  });
}

function setActiveMedia(root, mediaId) {
  root.querySelectorAll(selectors.productMedia).forEach((media) => {
    media.classList.toggle('is-active', String(media.dataset.mediaId) === String(mediaId));
  });

  root.querySelectorAll(selectors.mediaThumb).forEach((thumb) => {
    thumb.classList.toggle('is-active', String(thumb.dataset.mediaThumb) === String(mediaId));
  });
}

function resolveVariant(root) {
  const variantData = root.querySelector('[data-variants-json]');
  const hiddenVariantInput = root.querySelector(selectors.variantId);
  const priceTarget = root.querySelector(selectors.variantPrice);
  const addToCartButton = root.querySelector(selectors.addToCart);

  if (!variantData || !hiddenVariantInput) return;

  let variants;
  try {
    variants = JSON.parse(variantData.textContent);
  } catch (error) {
    return;
  }

  const selectedOptions = [];
  root.querySelectorAll('[data-product-option]').forEach((group) => {
    const selectedInput = group.querySelector(`${selectors.optionInput}:checked`) || group.querySelector(selectors.optionInput);
    if (selectedInput) {
      selectedOptions.push(selectedInput.value);
    }
  });

  let matchedVariant = variants.find((variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions));

  if (!matchedVariant) {
    matchedVariant = variants.find((variant) => Number(variant.id) === Number(hiddenVariantInput.value)) || variants[0];
  }

  if (!matchedVariant) return;

  hiddenVariantInput.value = matchedVariant.id;

  if (priceTarget) {
    priceTarget.textContent = matchedVariant.price;
  }

  if (addToCartButton) {
    addToCartButton.disabled = !matchedVariant.available;
    addToCartButton.textContent = matchedVariant.available ? `${addToCartButton.dataset.labelAvailable} — ${matchedVariant.price}` : addToCartButton.dataset.labelSoldOut;
  }

  if (matchedVariant.featured_media_id) {
    setActiveMedia(root, matchedVariant.featured_media_id);
  }
}

function bindProductForms() {
  document.querySelectorAll(selectors.productRoot).forEach((root) => {
    root.querySelectorAll(selectors.optionInput).forEach((input) => {
      input.addEventListener('change', () => resolveVariant(root));
    });

    root.querySelectorAll(selectors.mediaThumb).forEach((thumb) => {
      thumb.addEventListener('click', () => setActiveMedia(root, thumb.dataset.mediaThumb));
    });

    resolveVariant(root);
  });
}

function bindAccordions() {
  document.querySelectorAll(selectors.accordionToggle).forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.product-accordion__item');
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      item.classList.toggle('is-open', !expanded);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  bindMobileDrawer();
  bindProductForms();
  bindAccordions();
});
